// @flow @jsx h

import { h } from 'preact'

import styles from './StemningIcon.css'
import { bem } from '../../helpers/bem'
import { themeToClassName } from '../../helpers/themeToClassName'

export const StemningIcon = (props: any, context: { theme: string }) => {
  const { theme } = context

  return (
    <svg className={bem(styles.stemningIcon, themeToClassName(theme))}
      xmlns='http://www.w3.org/2000/svg' width='10' height='14'>
      <g fill-rule='evenodd'>
        <path d='M1 14c-.6 0-1-.4-1-1V8c0-.6.5-1 1-1 .6 0 1 .4 1 1v5c0 .6-.4 1-1 1M9 14a1 1 0 0 1-1-1V5c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1M5 14a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v12c0 .6-.5 1-1 1' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/StemningIcon/StemningIcon.js